import {IMsfFormBuilder} from '@components/form-builder/form-builder';
import {BidWorkTypeService} from '@6grain/masofa-monolith-api-client/dictionaries/api/bidWorkType.service';

export const BID_WORK_TYPE_IDS = {
  Default: 1,
  Experiment: 5,
} as const;

export function resolveBidWorkType(value: number | null | undefined): number {
  return value != null && value > 0 ? value : BID_WORK_TYPE_IDS.Default;
}

export function buildBidWorkTypeFormField(bidWorkTypeService: BidWorkTypeService): IMsfFormBuilder {
  return {
    name: 'bidWorkType',
    title: 'BID_WORK_TYPE',
    type: 'select',
    placeholder: 'BID_WORK_TYPE',
    selectService: bidWorkTypeService,
    selectServiceMethod: 'dictionariesBidWorkTypeGetByQueryPost',
    options: {
      select: {
        optionValue: 'id',
        translateBy: 'names',
      },
    },
  };
}
